var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPremium(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 26,
    viewBox: "0 0 30 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.1527 12.6426L14.6182 25.1793L2.08361 12.6426C0.734821 11.2551 -0.0136041 9.39242 0.000187273 7.45743C0.0139786 5.52243 0.788878 3.67062 2.1573 2.30248C3.52573 0.934344 5.3777 0.159833 7.3127 0.146447C9.2477 0.133061 11.1102 0.881877 12.4974 2.23095L13.0756 2.80914L14.6182 4.35168L16.1607 2.80914L16.7389 2.23095C17.419 1.53133 18.2313 0.973843 19.1288 0.590886C20.0262 0.20793 20.9907 0.00714106 21.9664 0.000187041C22.9421 -0.00676698 23.9094 0.180253 24.8122 0.550378C25.715 0.920504 26.5352 1.46636 27.2252 2.15621C27.9152 2.84607 28.4613 3.66618 28.8316 4.56889C29.2019 5.47159 29.3891 6.43889 29.3824 7.41458C29.3756 8.39026 29.175 9.35488 28.7923 10.2524C28.4095 11.1499 27.8522 11.9623 27.1527 12.6426Z",
    fill: "#705DF6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPremium);
export default __webpack_public_path__ + "static/media/premium.d95029c2ad21864fda3dfa236965b872.svg";
export { ForwardRef as ReactComponent };